import { request, Timeout } from './http'

export const getCountryCode = async () => {
  try {
    const geoRes = await request('https://skillbox.ru/_front/geo/', { timeout: Timeout.GEO })
    const geo = await geoRes.json()

    return geo.country_code.toLowerCase()
  } catch (e) {
    console.error(`Не удалось получить код страны: ${e}`) // eslint-disable-line no-console
    window.Sentry && window.Sentry.captureException(`Не удалось получить код страны: ${e}`)

    return null
  }
}
